import { useAuthState } from "react-firebase-hooks/auth";

import { firebaseAuth } from "@/services";
import { Role, appRoutes } from "@sr-partner-portal/common";

import { useEffectiveRole } from "@/hooks";
import type { ReactNode } from "react";
import { RestrictedRoute } from "./restricted-route";

// The start page of each role, matching the redirects of UnauthorizedRoute.
const roleHomeUrls = {
    [Role.ADMIN]: appRoutes(true).dashboard().build(),
    [Role.MANAGER]: appRoutes(true).dashboard().build(),
    [Role.CUSTOMER]: appRoutes(true).dashboard().build(),
    [Role.APPLICANT_MANAGER]: appRoutes(true)
        .applicantManagerDashboard()
        .build(),
};

const AuthenticatedRoute = ({
    children,
    roles,
}: {
    children: ReactNode;
    roles?: Array<keyof typeof Role>;
}) => {
    const [user] = useAuthState(firebaseAuth);
    const userRole = useEffectiveRole();

    const isValidUser = user !== null;
    const isValidRole = roles ? roles.includes(userRole) : true;

    // Signing out ends the session in every tab, so a signed-in user who may
    // not open this page is sent to the start page of their role instead.
    // Only a user without a known role is signed out.
    const redirectUrl = user
        ? (roleHomeUrls[userRole] ?? appRoutes(true).logout().build())
        : appRoutes(true).account().login().build();

    return (
        <RestrictedRoute
            condition={isValidUser && isValidRole}
            redirectUrl={redirectUrl}
        >
            {children}
        </RestrictedRoute>
    );
};

export { AuthenticatedRoute };
